module.exports = __webpack_public_path__ + "resources/img/logo.035bfd52.png";